import { TProcessingResult } from '@ws/shared/types';

import { ResultFormatter } from './ResultFormatter';

export abstract class Adaptor<T> extends ResultFormatter<T> {
  public adapt(value: T): TProcessingResult<T> {
    return this.createSuccessResponse(value);
  }
}
